export default {
    getSkills(state){
        return state.skills;
    }
}